<template>
  <div class="loginbgBox" v-show="showPage">
    <div class="app-wrap">
      <p class="app-box">
        <img class="icon-phone" src="@static/images/login/icon_phone.png" alt="" srcset="" />
        下载{{ appName || '保险中介云' }}APP
        <transition name="test" appear>
          <div class="qcode-wrap">
            <!-- <img class="app-logo" :src="appLogo" alt=""> -->
            <vueQr
              :text="downloadLink"
              v-if="downloadLink"
              :logoSrc="appLogo"
              :logoScale="0.3"
              :logoCornerRadius="0"
              :correctLevel="3"
              :size="112"
              :margin="5"
              id=""
            />
            <p class="text-info p-6">扫码下载</p>
            <p class="text-info">{{ appName || '保险中介云' }}APP</p>
          </div>
        </transition>
      </p>
    </div>
    <div class="logincontent">
      <div class="logo-box">
        <div class="web-name">
          <img class="logo-icon" src="@static/images/login/wtsLogo.png" />
          <span class="logo-title">梧桐树经纪人平台</span>
        </div>
      </div>
      <div class="content-right">
        <div class="form-box">
          <div class="form-title">梧桐树经纪人平台</div>
          <div id="wx_qrcode"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//当前实例组件
import vueQr from 'vue-qr';
import WwLogin from '@static/js/wwLogin-1.2.4';
export default {
  components: { vueQr },
  data: () => ({
    downloadLink: '', //app下载链接
    showPage: false,
    orgIco: localStorage.orgIco,
    orgName: '', //机构名称
    loading: false,
    orgCode: '', //机构code
    wxCode: '', //企业微信授权code
    appName: '保险中介云',
    appLogo: ''
  }),
  mounted() {
    this.wxCode = this.$route.query.code;
    if (this.wxCode) {
      this.loginByQcode();
    }else{
      this.showPage = true;
    }
    this.getOrgInfo();
    this.refreshCode();
  },
  methods: {
    // 获取商户信息
    getOrgInfo() {
      const orgCode = '260580000000800-wh';
      localStorage.orgCode = orgCode;
      if (!orgCode) {
        this.downloadLink = this.$config.h5Base + '/m/app';
        return;
      } else {
        this.downloadLink = this.$config.h5Base + `/m/${orgCode}/app`;
      }
      this.$http({
        url: '/buz/organizationBase/queryOrgCode',
        type: 'put',
        data: {
          orgCode: orgCode
        }
      })
        .then(res => {
          this.orgIco = res.data.ico;
          this.orgName = res.data.name;
          this.appLogo = res.data.appLogo;
          this.appName = res.data.appName;
        })
        .catch(() => {
        });
    },
    // 刷新企业微信二维码
    refreshCode() {
      let params = {
        //企业微信二维码
        id: 'wx_qrcode', // 登录页面显示二维码的容器id
        appid: 'ww84bf86fbc1f29e79', // 企业微信的CorpID，在企业微信管理端查看
        agentid: this.$config.env == 1 ? '1000213' : '1000124', // 授权方的网页应用id，在具体的网页应用中查看
        redirect_uri: encodeURIComponent(this.$config.base + '/wtsLogin'),
        lang: 'zh',
        href: 'impowerBox'
      };
      new WwLogin(params);
    },
    // 扫码登录
    loginByQcode() {
      this.$http({
        url: '/system/info/salesmanLogin/qrCode',
        type: 'post',
        data: { code: this.wxCode }
      })
        .then(res => {
          this.loading = false;
          this.login(res.data);
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.showPage = true;
        });
    },
    login(params) {
      if (!params.merVos || !params.merVos.length) {
        this.$notice.msg('商户信息不存在');
        return;
      }
      const data = {
        account: params.account,
        qwId: params.qwId,
        loginMode: params.qwId ? 3 : '',
        loginType: 3,
        merVo: params.merVos[0].merCode
      };
      this.$http({
        type: 'POST',
        url: `/system/userLogin`,
        query: {
          account: params.account,
          password: ''
        },
        data: data,
        forced: 1
      })
        .then(data => {
          this.loading = false;
          if (data.httpCode == 1) {
            localStorage.setItem('hasLogin', true);
            this.$router.replace('/');
          } else {
            this.$notice.msg(data.data || data.msg);
            this.showPage = true;
          }
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    }
  },
  destroyed() {}
};
</script>
<style lang="scss" scoped>
@import './login.scss';
</style>
